import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Profile',
    data () {
        return {
            user: {},
            activeLink: "edit-profile",
            img_url: service.imageURL,
            states: {},
            cities: {},
            setPanel: '',
            errorFlag: ''
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    methods: {
        //settings
        isActive(link){
            if(link == this.activeLink){
                return true;
            }
        },
        setComponent(attr,component){
            this.activeLink = attr;
            if(attr == 'set-password') {
                this.setPanel = "set-password";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           // this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.user = data.body.data;
                                    this.user.user_phone = "0"+this.user.user_phone;
                                    this.getCities(this.user.user_state); //populate the city
                                }
                            }).catch((err) => {
                                if(err) {
                                    toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            })
                         //../special case for profile
                         }, this);
                    }else {
                       this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        logout() {
            this.$router.push('/login');
        },

        resetPassword() {
            var credentials = {
                user_current_password: this.user.user_current_password,
                user_new_password: this.user.user_new_password,
                user: this.user.user_id
            }
            let navi = this.$router;
            if(credentials.user_current_password == '' || credentials.user_new_password == '' ) {
               toastr.warning("Kindly enter password", 'Warning!');
            }else if(credentials.user_current_password == null || credentials.user_new_password == null) {
                toastr.warning("Kindly enter password", 'Warning!');
            }else {
                service.resetPassword(this, credentials).then((response) => {
                    if(response.body.status == 200) {
                         navi.push('/login');   
                    }else{
                        this.errorFlag = response.body.message;
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                    }
                })
            }
        },

        resetEmail() {
            var credentials = {
                email: this.user.email,
                password: this.user.password,
            }

            if(credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else if(credentials.password == null || credentials.password == undefined || credentials.password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            }else {
                service.resetEmail(this, credentials).then((response) => {
                    if(response.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            localStorage.setItem("cityneeds_user", element.fullname);
                            //store session key here linked to session well @server

                            //display message here and redirect
                        }, this);
                        this.$router.push('dashboard');
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                    }
                })
            }
        },

        editProfile() {
            //let navi = this.$router;
            if(this.user.user_fullname != '' && this.user.user_phone != '' && this.user.user_city != 0) {
                service.editProfile(this, this.user, this.user.user_id).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Profile Updated!", "Success!");
                        location.reload(true); //vm.$forceUpdate(); -- let vm = new Vue @main.js #check
                    }else {
                        toastr.error('Sorry, could not update Profile', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                      toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

         //uploads
        onFileChange(e, user) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                formData.append('data_id', user);
                formData.append('data_type', "users");   
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        this.user.user_image = data.body.data;
                    }
                  }).catch((err) => {
                    if(err) {
                       // log it
                    }
                })
            }   
            
        },
       //--//uploads

        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCities(state) {
            service.getCities(this, state).then(data => {
                this.cities = data.body.data;
            })
        },

       
        //--//settings
        moveToPlans(){
            localStorage.setItem("cityneeds_request_plans","profile");
            this.$router.go('pricing');
        },
        

    },
    created: function(){
        this.preset();
        this.getStates();
    }
}


// WEBPACK FOOTER //
// ./src/components/Profile/script.js